import React, { Fragment, useContext } from 'react'

import { withRouter, RouteComponentProps } from 'react-router'

import { Header, Menu, Label } from 'semantic-ui-react'

import queryString from 'query-string'

import stepperConfigureIcon from '../../_images/stepper-configure.svg'
import stepperConfigureActiveIcon from '../../_images/stepper-configure-active.svg'
import stepperCollectIcon from '../../_images/stepper-collect.svg'
import stepperCollectActiveIcon from '../../_images/stepper-collect-active.svg'
import stepperCustomizeIcon from '../../_images/stepper-customize.svg'
import stepperCustomizeActiveIcon from '../../_images/stepper-customize-active.svg'
import stepperCollaborateIcon from '../../_images/stepper-collaborate.svg'
import stepperCollaborateActiveIcon from '../../_images/stepper-collaborate-active.svg'
import stepperCurateIcon from '../../_images/stepper-curate.svg'
import stepperCurateActiveIcon from '../../_images/stepper-curate-active.svg'
import stepperCompileIcon from '../../_images/stepper-compile.svg'
import stepperCompileActiveIcon from '../../_images/stepper-compile-active.svg'

import { UserContext } from '../../contexts/UserContext'

import Auth from '../../utils/Auth'
import { ProjectSectionTab } from './SideBarSecondary.types'

const adminMemberSectionOptions: ISectionOption[] = [
  {
    section: 'configure',
    sectionName: 'Configure',
    icon: stepperConfigureIcon,
    activeIcon: stepperConfigureActiveIcon,
    tabs: [
      {
        tab: 'overview',
        tabName: 'Overview & Settings',
      },
    ],
  },
  {
    section: 'collect',
    sectionName: 'Collect',
    icon: stepperCollectIcon,
    activeIcon: stepperCollectActiveIcon,
    tabs: [
      {
        tab: 'landingPage',
        tabName: 'Video Form Builder',
      },
      {
        tab: 'questions',
        tabName: 'Video Survey Builder',
      },
      {
        tab: 'dataCollection',
        tabName: 'Contributor Data',
      },
      {
        tab: 'successPage',
        tabName: 'Thank You Page Builder',
      },
    ],
  },
  {
    section: 'collaborate',
    sectionName: 'Collaborate',
    icon: stepperCollaborateIcon,
    activeIcon: stepperCollaborateActiveIcon,
    tabs: [
      {
        tab: 'sharing',
        tabName: 'Shareable Upload Link',
      },
      /*
      {
        tab: 'contest',
        tabName: 'Public Video Gallery',
      },
      */
    ],
  },
  {
    section: 'curate',
    sectionName: 'Curate',
    icon: stepperCurateIcon,
    activeIcon: stepperCurateActiveIcon,
    tabs: [
      {
        tab: null,
        tabName: 'Project Video Library',
      },
    ],
  },
  {
    section: 'customize',
    sectionName: 'Customize',
    icon: stepperCustomizeIcon,
    activeIcon: stepperCustomizeActiveIcon,
    tabs: [
      {
        tab: 'videoLayout',
        tabName: 'Video Template Builder',
      },
    ],
  },
  {
    section: 'compile',
    sectionName: 'Compile',
    icon: stepperCompileIcon,
    activeIcon: stepperCompileActiveIcon,
    tabs: [
      {
        tab: null,
        tabName: 'Project Downloads',
      },
    ],
  },
  /*
  {
    section: 'claim',
    sectionName: 'Claim',
    icon: stepperClaimIcon,
    activeIcon: stepperClaimActiveIcon,
    tabs: [
      {
        tab: null,
        tabName: 'Consent Report',
      },
    ],
  },
  */
]

const sectionOptionsCollaborator: ISectionOption[] = [
  {
    section: 'configure',
    sectionName: 'Configure',
    icon: stepperConfigureIcon,
    activeIcon: stepperConfigureIcon,
    tabs: [
      {
        tab: 'overview',
        tabName: 'Overview & Settings',
      },
    ],
  },
  {
    section: 'curate',
    sectionName: 'Curate',
    icon: stepperCurateIcon,
    activeIcon: stepperCurateActiveIcon,
    tabs: [
      {
        tab: null,
        tabName: 'Project Video Library',
      },
    ],
  },
]

const SideBarSecondary = ({ history, location, goToPage }: IProps) => {
  const { isAdmin } = Auth.getPayLoad()
  const { userProfile } = useContext(UserContext)

  const { pathname, search } = location

  // e.g. https://studio.vloggi.com/projects/MBN-000/configure?tab=langingPage
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const [domain, resource, projectSlug, currentSection] = pathname.split('/')

  const { tab } = queryString.parse(search)

  const currentTab = tab ? String(tab) : null

  console.log('Rendering Secondary Side Bar')

  // Is user collaborator
  const isUserCollaborator = (): boolean => {
    return userProfile.userAccessRights === 'collaborator'
  }

  const sectionOptions = isUserCollaborator() ? sectionOptionsCollaborator : adminMemberSectionOptions

  return (
    <>
      <div style={{ 
        backgroundColor: '#13165a', 
        position: 'relative', 
        width: '100%', 
        height: '62px', 
        padding: '8px 16px',
        boxSizing: 'border-box',
        borderBottom: 'none', // Ensure no border on bottom
        boxShadow: 'none' // Remove any shadow that might be applied
      }}> 
      </div>

      <div style={{ marginLeft: '0.5rem' }}>
        {sectionOptions.map(({ section, sectionName, activeIcon, icon, tabs }) => (
          <Fragment key={section}>
            <Header
              as="h5"
              style={{ fontWeight: '700', margin: '0.5rem 0 0 0' }}
              image={currentSection === section ? activeIcon : icon}
              content={sectionName}
            />

            <Menu compact text vertical style={{ marginTop: '0.5rem ' }}>
              {tabs.map(({ tab, tabName, isNew, shouldShowOnlyAdmin }) =>
                shouldShowOnlyAdmin && !isAdmin ? null : (
                  <Menu.Item
                    key={tabName}
                    name={tabName}
                    color="violet"
                    active={currentSection === section && currentTab === tab}
                    style={{
                      borderRadius: '0',
                      borderLeft: '2px solid #e2e2e2',
                      padding: '0.75rem',
                      margin: '0 0 0 9px',
                    }}
                    onClick={() => goToPage(`/projects/${projectSlug}/${section}${tab ? `?tab=${tab}` : ''}`)}
                  >
                    {isNew && <Label color="red" size="mini" horizontal content="New" />}
                    {tabName}
                  </Menu.Item>
                )
              )}
              {/* Add video template management if user is an admin */}
              {isAdmin && section === 'customize' && (
                <Menu.Item
                  key="Template Admin"
                  name="Template Admin"
                  color="violet"
                  active={currentSection === section && currentTab === 'templateAdmin'}
                  style={{
                    borderRadius: '0',
                    borderLeft: '2px solid #e2e2e2',
                    padding: '0.5rem',
                    margin: '0 0 0 9px',
                  }}
                  onClick={() => goToPage(`/projects/${projectSlug}/customize?tab=templateAdmin`)}
                />
              )}
            </Menu>
          </Fragment>
        ))}
      </div>
    </>
  )
}

interface ISectionOption {
  section: string
  sectionName: string
  icon: string
  activeIcon: string
  tabs: {
    tab: ProjectSectionTab | null
    tabName: string
    isNew?: boolean
    shouldShowOnlyAdmin?: boolean
  }[]
}

interface IProps extends RouteComponentProps<any> {
  goToPage: (args: string) => void
}

export default withRouter(SideBarSecondary)
